import React, { useEffect, useState } from 'react';
import './VeiculoseciaHeader.scss';
import logo from '../../../assets/images/logo.png';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import { MdClose, MdMenu, MdMenuOpen, MdWhatsapp } from 'react-icons/md';
import { IconButton } from '@mui/material';

function VeiculoseciaHeader() {
    const navigate = useNavigate();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            setWindowWidth(currentWidth);
        }

        window.addEventListener('resize', handleResize);

        if (windowWidth > 992) {
            setIsOpenMenu(false);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [windowWidth])


    const handleScrollToSection = (sectionId) => {
        // Se já estiver na HomePage, rolamos diretamente
        if (window.location.pathname === '/') {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            // Se não estiver na HomePage, navegamos para ela com o hash
            navigate(`/#${sectionId}`);
        }
    };

    return (
        <>
            <div
                className={`menuOverlay ${isOpenMenu ? 'show' : 'd-none'}`}
                onClick={() => setIsOpenMenu(false)}
            />
            <div className={`menuWrapper ${isOpenMenu ? 'toggle' : ''}`}>
                <div className='menu__content p-2 h-100'>
                    <div className='d-flex justify-content-end mb-2'>
                        <IconButton
                            onClick={() => setIsOpenMenu(false)}
                            sx={{ '& svg': { fill: '#d32f2f !important' } }}
                        >
                            <MdClose />
                        </IconButton>
                    </div>
                    <div className='d-flex flex-column'>
                        <Button className='veiculoseciaHeader__btn mb-3' onClick={() => navigate('/')}>Início</Button>
                        <Button className='veiculoseciaHeader__btn mb-3' onClick={() => handleScrollToSection('quem-somos')}>Sobre Nós</Button>
                        <Button className='veiculoseciaHeader__btn mb-3' onClick={() => navigate('/financiamento')}>Financiamento</Button>
                        <Button className='veiculoseciaHeader__btn mb-3' onClick={() => navigate('/estoque')}>Estoque</Button>
                        <Button className='veiculoseciaHeader__btn mb-3' onClick={() => navigate('/contato')}>Contato</Button>
                        <Button
                            className='veiculoseciaHeader__btn'
                            startIcon={<MdWhatsapp />}
                            onClick={() => window.open('https://api.whatsapp.com/send/?phone=5566999815612&text=Olá, estou interessado em adquirir um veículo', '_blank')}
                        >
                            (66) 99981-5612
                        </Button>
                    </div>
                </div>
            </div>

            <header className='veiculoseciaHeader d-flex align-items-center'>
                <div className='veiculoseciaHeader__content container-fluid w-100'>
                    <div className='row d-flex align-items-center justify-content-between w-100 flex-row'>
                        <div className='col-sm-2 part1'>
                            <Link to='/' className='d-flex align-items-center logo'>
                                <img src={logo} alt='logo' />
                            </Link>
                        </div>

                        <div className='col-sm-8 d-flex align-items-center justify-content-end'>
                            {windowWidth > 992 ? (
                                <>
                                    <Button className='veiculoseciaHeader__btn me-2' onClick={() => navigate('/')}>Início</Button>
                                    <Button className='veiculoseciaHeader__btn me-2' onClick={() => handleScrollToSection('quem-somos')}>Sobre Nós</Button>
                                    <Button className='veiculoseciaHeader__btn me-2' onClick={() => navigate('/financiamento')}>Financiamento</Button>
                                    <Button className='veiculoseciaHeader__btn me-2' onClick={() => navigate('/estoque')}>Estoque</Button>
                                    <Button className='veiculoseciaHeader__btn me-2' onClick={() => navigate('/contato')}>Contato</Button>
                                    <Button
                                        className='veiculoseciaHeader__btn'
                                        startIcon={<MdWhatsapp />} sx={windowWidth < 1050 && { '& span': { margin: 0 } }}
                                        onClick={() => window.open('https://api.whatsapp.com/send/?phone=5566999815612&text=Olá, estou interessado em adquirir um veículo', '_blank')}
                                    >
                                        {windowWidth > 1050 && '(66) 99981-5612'}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <IconButton
                                        onClick={() => setIsOpenMenu(true)}
                                    >
                                        {isOpenMenu ? <MdMenuOpen /> : <MdMenu />}
                                    </IconButton>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default VeiculoseciaHeader;
